import type { ExamFormData } from './examValidation';


// History assessment scoring function
export function calculateHistoryScore(historyData: ExamFormData['history']): number {
  if (!historyData) return 0;

  let totalCheckedItems = 0;
  
  // Count chronic diseases checked
  if (historyData.chronicDiseases && historyData.chronicDiseases.length > 0) {
    totalCheckedItems += historyData.chronicDiseases.length;
  }
  
  // Count additional single checkbox questions
  if (historyData.additionalOtherChronic) totalCheckedItems += 1;
  if (historyData.additionalSurgery) totalCheckedItems += 1;
  if (historyData.additionalMedications) totalCheckedItems += 1;
  if (historyData.additionalAllergies) totalCheckedItems += 1;
  
  // Count family chronic diseases checked
  if (historyData.familyChronicDiseases && historyData.familyChronicDiseases.length > 0) {
    totalCheckedItems += historyData.familyChronicDiseases.length;
  }
  
  // Count other chronic diseases checkbox
  if (historyData.otherChronicDiseasesCheck) totalCheckedItems += 1;
  
  // Start with 100% and subtract 5 points for each checked item
  const score = Math.max(0, 100 - (totalCheckedItems * 5));
  
  return score;
}

// Physical assessment scoring function
export function calculatePhysicalScore(formData: ExamFormData): number {
  if (!formData.bmi || formData.bmi <= 0) return 0;

  const idealBMI = 22; // Ideal BMI value
  const bmi = formData.bmi;
  
  // Start with 100% score
  let score = 100;
  
  // If BMI is above ideal, subtract 2 points for every point above ideal
  if (bmi > idealBMI) {
    const excessBMI = bmi - idealBMI;
    score = Math.max(0, 100 - (excessBMI * 2)); // Ensure score doesn't go below 0
  }
  
  return Math.round(score);
}


// Main function to calculate score for any section
export function calculateSectionScore(sectionId: string, formData: ExamFormData): number {
  switch (sectionId) {
    case 'history':
      return calculateHistoryScore(formData.history);
    case 'physical':
      return calculatePhysicalScore(formData);
    default:
      return 0;
  }
} 